import React, { useState } from 'react';
import { updateUser } from '../services/api';
import Button from '../components/Button';
import './Settings.css';

const Settings = () => {
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await updateUser({ password });
      setMessage('Password updated successfully!');
      setPassword('');
    } catch (error) {
      setMessage('Failed to update password.');
      console.error('Password update failed', error);
    }
  };

  return (
    <div className="settings-container">
      <h1>Settings</h1>
      <form className="form" onSubmit={handleSubmit}>
        <div className="form-group">
          <label>New Password</label>
          <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} />
        </div>
        <Button type="submit">Update Password</Button>
      </form>
      {message && <p>{message}</p>}
    </div>
  );
};

export default Settings;
